module.exports = {"232721100":"呼玛镇","232721101":"韩家园镇","232721200":"三卡乡","232721201":"金山乡","232721202":"兴华乡","232721203":"鸥浦乡","232721204":"白银纳鄂伦春族民族乡","232721205":"北疆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/232721.json
// module id = 900
// module chunks = 0